var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarcas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_93",
    "data-name": "Rect\\xE1ngulo 93",
    width: 18.524,
    height: 18.625,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Marcas"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marcas",
    clipPath: "url(#clip-Marcas)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_244",
    "data-name": "Grupo 244",
    transform: "translate(5.738 5.688)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_135",
    "data-name": "Trazado 135",
    d: "M38.675,14.311a1.9,1.9,0,0,0-1.68.544,2.241,2.241,0,0,1-1.159.614,1.605,1.605,0,0,1-1.165-.3c-.308-.221-.6-.464-.925-.661a1.432,1.432,0,0,0-.6-.194c-.36-.031-.726,0-1.089-.01a1.583,1.583,0,0,1-1.59-1.17c-.12-.359-.221-.725-.361-1.076a1.08,1.08,0,0,0-.3-.417c-.285-.236-.6-.439-.9-.659a1.6,1.6,0,0,1-.624-1.917c.11-.345.242-.685.327-1.037a1.277,1.277,0,0,0,0-.584c-.095-.382-.241-.751-.354-1.129a1.571,1.571,0,0,1,.581-1.763c.309-.233.639-.44.933-.69a1.338,1.338,0,0,0,.358-.494c.144-.349.237-.718.359-1.077a1.594,1.594,0,0,1,1.531-1.123c.4-.007.792.014,1.186-.01A1.129,1.129,0,0,0,33.712,1c.32-.2.616-.442.924-.662a1.585,1.585,0,0,1,1.956,0c.309.22.6.46.924.662a1.132,1.132,0,0,0,.512.168c.386.025.774,0,1.162.009a1.594,1.594,0,0,1,1.567,1.14c.124.366.225.741.368,1.1a1.14,1.14,0,0,0,.319.435c.291.242.61.45.915.675a1.6,1.6,0,0,1,.608,1.861c-.113.361-.253.715-.345,1.081a1.19,1.19,0,0,0,0,.562c.1.4.252.782.367,1.176a1.563,1.563,0,0,1-.561,1.705c-.32.245-.662.463-.97.722a1.273,1.273,0,0,0-.345.473c-.138.334-.229.687-.344,1.031a1.587,1.587,0,0,1-1.611,1.176c-.161,0-.323,0-.484,0M32.9,10.778a.487.487,0,0,0,.743.479q.9-.462,1.8-.944a.323.323,0,0,1,.353,0c.58.315,1.168.618,1.752.927a.533.533,0,0,0,.551.035c.2-.117.274-.32.219-.636-.111-.643-.214-1.288-.336-1.929a.3.3,0,0,1,.108-.314c.488-.47.971-.945,1.456-1.419a.479.479,0,0,0,.159-.522.5.5,0,0,0-.448-.347c-.662-.093-1.323-.2-1.986-.284a.35.35,0,0,1-.3-.226c-.281-.589-.577-1.171-.862-1.757a.5.5,0,0,0-.965,0c-.285.587-.581,1.169-.862,1.757a.35.35,0,0,1-.3.226c-.647.085-1.292.19-1.938.277a.5.5,0,0,0-.288.927c.424.409.831.836,1.27,1.227a.614.614,0,0,1,.21.669c-.133.63-.224,1.269-.324,1.856",
    transform: "translate(-26.355 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_136",
    "data-name": "Trazado 136",
    d: "M178.515,185.4l.986.991c.4.4.8.8,1.2,1.2.361.364.287.731-.186.918-.675.266-1.349.533-2.027.789a.449.449,0,0,0-.29.287q-.4,1.051-.818,2.094a.482.482,0,0,1-.836.177c-.958-.949-1.908-1.9-2.861-2.858a.441.441,0,0,1-.044-.063,1.082,1.082,0,0,1,.855-.356,5.529,5.529,0,0,0,1.3-.058,2.317,2.317,0,0,0,1.782-1.51,4.726,4.726,0,0,0,.265-.8,1.1,1.1,0,0,1,.676-.808",
    transform: "translate(-162.403 -173.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_137",
    "data-name": "Trazado 137",
    d: "M7.328,189.567c-.172.155-.346.3-.506.457q-1.185,1.178-2.365,2.362c-.383.382-.747.306-.945-.2-.265-.675-.522-1.353-.8-2.024a.512.512,0,0,0-.253-.253c-.671-.275-1.349-.531-2.025-.8-.5-.2-.578-.557-.193-.943.673-.674,1.35-1.345,2.018-2.023.121-.123.2-.152.358-.041a1.019,1.019,0,0,1,.438.6,7.2,7.2,0,0,0,.3.895,2.384,2.384,0,0,0,2.161,1.57,5.58,5.58,0,0,0,.943,0,1.052,1.052,0,0,1,.87.388",
    transform: "translate(0 -174.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_138",
    "data-name": "Trazado 138",
    d: "M108.583,83.1c-.431-.227-.827-.422-1.21-.64a.708.708,0,0,0-.772,0c-.381.22-.777.412-1.208.638.079-.459.134-.874.225-1.28a.8.8,0,0,0-.263-.842c-.307-.282-.577-.606-.869-.919.265-.041.56-.088.857-.131.959-.138.8-.046,1.215-.869.136-.272.271-.545.431-.866.193.39.387.73.533,1.09a.861.861,0,0,0,.83.608c.392.02.78.11,1.145.165-.291.31-.564.638-.877.924a.793.793,0,0,0-.262.841c.091.406.146.82.225,1.277",
    transform: "translate(-97.726 -73.138)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarcas);
export default __webpack_public_path__ + "static/media/Marcas.498a59cac8f3c90b7e486ca2782b8df7.svg";
export { ForwardRef as ReactComponent };